<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยีต่างๆ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <!-- <i class="fa fa-dashboard"></i> รายงานจำนวนรายการส่งเสริมการขายบริการโทรศัพท์เคลื่อนที่จำแนกตามประเภทบริการ -->
          </a>
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทรายงาน" required>
                            <el-select
                              ref="type_report"
                              v-model="form.type_report"
                              @change="clear_data"
                            >
                              <el-option label="รายเดือน" value="month"></el-option>
                              <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                              <el-option label="รายปี" value="year"></el-option>
                              <el-option label="ระหว่างปี" value="between_year"></el-option>
                              <el-option label="ไตรมาส" value="quarter"></el-option>
                              <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="รายชื่อผู้ให้บริการ" required>
                            <el-radio-group v-model="form.provider_list" :disabled="!checkProviders()">
                              <el-radio
                                 ref="provider_list"
                                    v-for="provider in this.store_providers" 
                                    :key="provider.id" 
                                    :label="provider.id">{{provider.brand_name}}
                              </el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item
                            label="กรุณาเลือกประเภทรายงาน"
                            v-if="form.type_report === ''"
                          >
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            default-value="2556"
                            v-bind:class="[form.type_report === 'month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="month"
                              v-model="form.type_data.month"
                              style="width:100%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="monthfrom"
                              v-model="form.type_data.monthfrom"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>&nbsp;-&nbsp;
                            <el-date-picker
                              ref="monthto"
                              v-model="form.type_data.monthto"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="year"
                              v-model="form.type_data.year"
                              style="width:100%;"
                              type="year"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="yearfrom"
                              v-model="form.type_data.yearfrom"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-date-picker
                              ref="yearto"
                              v-model="form.type_data.yearto"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:50%;"
                              ref="quarter"
                              v-model="form.type_data.quarter"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-if="form.type_report === 'between_quarter'"
                            v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:20%;"
                              ref="quarterfrom"
                              v-model="form.type_data.quarterfrom"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year_from"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;&nbsp;-&nbsp;
                            <el-select
                              style="width:20%;"
                              ref="quarterto"
                              v-model="form.type_data.quarterto"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ประเภทเทคโนโลยี" required>
                            <el-checkbox-group
                              ref="type_technology"
                              v-model="form.type_data.checkList"
                            >
                              <el-checkbox label="ADSL">ADSL</el-checkbox>
                              <el-checkbox label="VDSL">VDSL</el-checkbox>
                              <el-checkbox label="FTTx">FTTx</el-checkbox>
                              <el-checkbox label="WiFi">WIFI</el-checkbox>
                              <el-checkbox label="VAS">VAS</el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                              <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                              <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="find_report()">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                  <div class="box-body" style="min-height: 500px;" v-if="show && showTable">
                    <div class="col-sm-12">
                      <div class="row" >
                        <div
                          class="col-sm-12"
                          style="width:100%;text-align:right;padding-bottom:20px"
                        >
                          <div class="col-sm-11" style="text-align:right;">
                            <el-dropdown @command="exportFile" v-loading="pending">
                              <span class="btn btn-primary" >
                                Export<i class="el-icon-arrow-down el-icon--right"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-download" command="xls">Export XLS</el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                        </div>
                        <div class="col-sm-1"></div>
                        <div class="col-sm-10" ref="dataTable" id="data">
                          <h4
                            align="center"
                          >รายงานรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยี</h4>
                          <h4 align="center">{{this.title}}</h4>
                          <table border="1" style="background-color: #ffebcc">
                            <tr id="header" align="center" style="width:100%; background-color: #ffcc80">
                              <th>เทคโนโลยี</th>
                              <th>ชื่อรายการส่งเสริมการขาย</th>
                              <th>
                                ความเร็ว
                                <br />(Download/Upload)
                              </th>
                              <th>ค่าบริการต่อเดือน 
                                <br />(บาท)
                              </th>
                            </tr>
                            <tr v-for="item_table in data_table" v-bind:key="item_table.id">
                              <template v-if="item_table.rowspan > 1">
                                <td align="center" :rowspan="item_table.rowspan">{{item_table.type_technology}}</td>
                                <td v-if="item_table.promotion_name_th != '-'" align="left">&nbsp;{{item_table.promotion_name_th}}</td>
                                <td v-else align="center">{{item_table.promotion_name_th}}</td>
                                <td align="center">{{item_table.speed}}</td>
                                <td align="center">{{item_table.price_avg ? item_table.price_avg : '-'}}</td>
                              </template>
                              <template v-else-if="item_table.rowspan == 1">
                                <td align="center">{{item_table.type_technology}}</td>
                                <td v-if="item_table.promotion_name_th != '-'" align="left">&nbsp;{{item_table.promotion_name_th}}</td>
                                <td v-else align="center"> {{item_table.promotion_name_th}}</td>
                                <td align="center">{{item_table.speed}}</td>
                                <td align="center">{{item_table.price_avg ? item_table.price_avg : '-'}}</td>
                              </template>
                              <template v-else-if="item_table.rowspan == 0">
                                <td v-if="item_table.promotion_name_th != '-'" align="left">&nbsp;{{item_table.promotion_name_th}}</td>
                                <td v-else align="center"> {{item_table.promotion_name_th}}</td>
                                <td align="center">{{item_table.speed}}</td>
                                <td align="center">{{item_table.price_avg ? item_table.price_avg : '-'}}</td>
                              </template>
                            </tr>
                          </table>
                          <div style="text-align:center;margin-top:3%">
                            <b>หมายเหตุ: {{note}}</b>
                          </div>
                        </div>
                        <div class="col-sm-1"></div>
                      </div>
                    </div>
                  </div>
                  <div class="box-body" v-if="showDataNotFound">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลการค้นหา</h4>
                    </div>
                 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom, Table, TableCell, TableRow, RelativeHorizontalPosition, WidthType, VerticalAlign, TextRun, BorderStyle } from "docx";
import utility from "../../lib/utility";
import jsPDF from "jspdf";
export default {
  data() {
    return {
      show: false,
      label_position: "top",
      form: {
        type_data: {
          service: "",
          checkList: [],
          quarter: "",
          year: "",
          month: "",
          monthfrom: "",
          monthto: "",
          quarter_year_from: "",
          quarter_year: "",
          quarterfrom: [],
          quarterto: [],
          yearfrom: "",
          yearto: ""
        },
        type_report: "",
        service_status: ['S','U','CS','CU'],
        type_providers: "provider",
        provider_group: [],
        provider_list:[]
      },
      pending: false
    };
  },
  created() {
    this.$store.dispatch('Report_pmt/getGroupCompany','broadband')
    this.$store.dispatch('Report_pmt/getProviderByType','broadband')
  },
  computed: {
    ...mapState({
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      data_table: store => store.Report_G9.data_table,
      note: store => store.Report_G9.note,
      showTable: store => store.Report_G9.showTable,
      showDataNotFound: store => store.Report_G9.showDataNotFound,
      title: store => store.Report_G9.title,
      bgTable: store => store.Report_G9.bgTable
    })
  },
  beforeUpdate() {},
  mounted() {},
  methods: {
    ...mapActions({
      searching : 'Report_G9/report_data'
    }),
    checkProviders() {
      if (this.form.type_providers == 'group') {
        this.form.provider_list = ""
        return false
      } else {
        this.form.provider_group = ""
        return true
      }
    },
    
    clear_data() {
      this.form.type_data = {
        service: "",
        checkList: this.form.type_data.checkList,
        monthfrom: "",
        monthto: "",
        quarter: "",
        quarter_year: "",
        year: "",
        month: "",
        quarterfrom: "",
        quarterto: "",
        yearfrom: "",
        yearto: ""
      };
    },
    find_report() {
      if (this.form.type_report === "") {
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
      } else if (
        this.form.type_report === "month" &&
        this.form.type_data.month === ""
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.month.focus();
          }
        });
      } else if (
        this.form.type_report === "between_month" &&
        (this.form.type_data.monthfrom === "" ||
          this.form.type_data.monthto === "")
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.monthfrom.length == 0) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
      } else if (
        this.form.type_report === "year" &&
        this.form.type_data.year === ""
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
      } else if (
        this.form.type_report === "between_year" &&
        (this.form.type_data.yearfrom.length === 0 ||
          this.form.type_data.yearto.length === 0)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom.length == 0) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
      } else if (
        this.form.type_report === "quarter" &&
        (this.form.type_data.quarter === "" ||
          this.form.type_data.quarter_year.length === 0)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
            if (this.form.type_data.quarter.length == 0) {
              this.$refs.quarter.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      } else if (
        this.form.type_report === "between_quarter" &&
        (this.form.type_data.quarterfrom.length === 0 ||
          this.form.type_data.quarterto.length === 0 ||
          this.form.type_data.quarter_year === "")
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.quarterfrom.length === 0) {
              this.$refs.quarterfrom.focus();
            } else if (this.form.type_data.quarterto.length === 0) {
              this.$refs.quarterto.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      } else if (this.form.type_providers=="group"&& this.form.provider_group.length == 0 ) {
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {}
        });
      }else if (this.form.type_providers=="provider"&& this.form.provider_list.length == 0 ) {
        this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {}
        });
      }else if (this.form.type_data.checkList.length === 0) {
        this.$alert("กรุณาเลือกประเภทเทคโนโลยี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {}
        });
      } else {//find data
        let formdata = this.form
        formdata.list = this.form.type_providers == "group" ? this.store_groups.filter(item => this.form.provider_group == item.id) : this.store_providers.filter(item => this.form.provider_list == item.id)
        this.show = true
        this.searching(formdata)
      }
    },
    getTableRepeat(){
      var style = `<style>
                  table.gridtable     { page-break-after: auto; }
                    table.gridtable   tr    { page-break-inside:avoid;page-break-after: auto; }
                    table.gridtable   td    { page-break-inside:avoid; page-break-after:auto }
                    table.gridtable   thead { display:table-header-group }
                    table.gridtable   tfoot { display:table-footer-group }
                </style>`
      // var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
      var header = "<html "+
            // "xmlns:w='urn:schemas-microsoft-com:office:word' "+
            // "xmlns='http://www.w3.org/TR/REC-html40'>"+
            "xmlns:xsl='http://www.w3.org/1999/XSL/Transform'" +
            "xmlns:fo='http://www.w3.org/1999/XSL/Format'"  +
            "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title>" + style + "</head><body>";
      var footer = "</body></html>";
      var sourceHTML = header+document.getElementById("data").innerHTML+footer;
      let title = `<h4 align="center" style="page-break-before: always;">รายงานรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยี</h4>
                    <h4 align="center">${this.title}</h4>`
      let footer_note = `<div style="text-align:center;margin-top:3%">
                        <b>หมายเหตุ: ${this.note}</b>
                      </div>`
      let table_header = `<thead><tr id="header" align="center" style="width: 100%; background-color: rgb(255, 204, 128);">
            <th style="width: 20%;">เทคโนโลยี</th><th style="width: 30%;">ชื่อรายการส่งเสริมการขาย</th><th style="width: 25%;">ความเร็ว<br>(Download/Upload)</th><th style="width: 25%;">ค่าบริการต่อเดือน<br>(บาท)</th>
          </tr></thead>`
        let data = title + `<table class="gridtable" border="1" align="center" style="background-color: rgb(255, 235, 204); width: 100%;">`
        data += table_header
        let current_technology = ''
        let left_span = 0
        let current_span = 1
        for(let i = 0; i < this.data_table.length; i++) {
          if (current_technology != this.data_table[i].type_technology) {
            current_technology = this.data_table[i].type_technology
            current_span = this.data_table[i].rowspan > 0 ? this.data_table[i].rowspan : 0
          } else {
            current_span = 0
          }
            if (current_span > 0) {
              data += `<tr><td align="center" rowspan="${current_span}">${current_technology}</td><td align="${this.data_table[i].promotion_name_th == '-' ? 'center' : 'left'}">${this.data_table[i].promotion_name_th}</td><td align="center">${this.data_table[i].speed}</td><td align="center">${this.data_table[i].price_avg ? this.data_table[i].price_avg : '-'}</td></tr>`
            } else {
              data += `<tr><td align="${this.data_table[i].promotion_name_th == '-' ? 'center' : 'left'}">${this.data_table[i].promotion_name_th}</td><td align="center">${this.data_table[i].speed}</td><td align="center">${this.data_table[i].price_avg ? this.data_table[i].price_avg : '-'}</td></tr>`
            }
        }
        data += `</table>`
        data += footer_note
      return data
    },
    exportFile(com){
      if(com=="pdf"){
        let data = this.getTableRepeat();
        let element = new DOMParser().parseFromString("<div id='table'>"+data+"</div>", "text/html");
        var divContents = element.firstChild.getElementsByTagName("div")[0].outerHTML;

        var printWindow = window.open('', '', 'height=400,width=1050,scrollbars=1');        
        //สร้าง popup
        printWindow.document.write('<html><head><title>' + this.title + '</title>');
        printWindow.document.write('<link href="TableCSS.css" rel="stylesheet" type="text/css" />'); //css path  
        printWindow.document.write('<style>table {border-collapse: collapse;}</style>')
        printWindow.document.write('</head><body onLoad="self.print();">'); // สั่ง Print เมื่อ reder เสร็จ
        printWindow.document.write(divContents);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
      }else if(com=="doc"){
        var style = `<style>
                        table.gridtable     { page-break-after: auto; }
                          table.gridtable   tr    { page-break-inside:avoid;page-break-after: auto; }
                          table.gridtable   td    { page-break-inside:avoid; page-break-after:auto }
                          table.gridtable   thead { display:table-header-group }
                          table.gridtable   tfoot { display:table-footer-group }
                      </style>`
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                      "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                      "xmlns='http://www.w3.org/TR/REC-html40'>"+
                      "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title>" + style + "</head><body>";
        var footer = "</body></html>";
        var sourceHTML = header+document.getElementById("data").innerHTML+footer;
        let title = `<h4 align="center" style="page-break-before: always;">รายงานรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยี</h4>
                      <h4 align="center">${this.title}</h4>`
        let footer_note = `<div style="text-align:center;margin-top:3%">
                            <b>หมายเหตุ: ${this.note}</b>
                          </div>`
        let table_header = `<thead><tr id="header" align="center" style="width: 100%; background-color: rgb(255, 204, 128);">
                              <th style="width: 20%;">เทคโนโลยี</th><th style="width: 30%;">ชื่อรายการส่งเสริมการขาย</th><th style="width: 25%;">ความเร็ว<br>(Download/Upload)</th><th style="width: 25%;">ค่าบริการต่อเดือน<br>(บาท)</th>
                            </tr></thead>`
        let data = title + `<table class="gridtable" border="1" align="center" style="background-color: rgb(255, 235, 204); width: 100%;">`
        data += table_header
        let current_technology = ''
        let left_span = 0
        let current_span = 1
        for(let i = 0; i < this.data_table.length; i++) {
          if (current_technology != this.data_table[i].type_technology) {
            current_technology = this.data_table[i].type_technology
            current_span = this.data_table[i].rowspan > 0 ? this.data_table[i].rowspan : 0
          } else {
            current_span = 0
          }
          if (current_span > 0) {
            data += `<tr><td align="center" rowspan="${current_span}">${current_technology}</td><td align="${this.data_table[i].promotion_name_th == '-' ? 'center' : 'left'}">${this.data_table[i].promotion_name_th}</td><td align="center">${this.data_table[i].speed}</td><td align="center">${this.data_table[i].price_avg ? this.data_table[i].price_avg : '-'}</td></tr>`
          } else {
            data += `<tr><td align="${this.data_table[i].promotion_name_th == '-' ? 'center' : 'left'}">${this.data_table[i].promotion_name_th}</td><td align="center">${this.data_table[i].speed}</td><td align="center">${this.data_table[i].price_avg ? this.data_table[i].price_avg : '-'}</td></tr>`
          }
        }
        data += `</table>`
        data += footer_note
        // let data = this.getTableRepeat()
        var sourceHTML = header+data+footer;
        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Report9.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      }else if(com=="xls"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
            "xmlns:w='urn:schemas-microsoft-com:office:word' "+
            "xmlns='http://www.w3.org/TR/REC-html40'>"+
            "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header+document.getElementById("data").innerHTML+footer;
        var source = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Report.xls';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      }
    },
  }
};
</script>
<style>
.el-dropdown-link {
    cursor: pointer;
    color: #FFFF;
    background-color: blue;
 }
table,
td,
th {
  /* border: 1px solid black; */
}

table {
  /* border-collapse: collapse; */
  width: 100%;
}
table tr th {
  text-align: center;
  height: 55px;
}
th,
tr {
  height: 30px;
  text-align: center;
  width: 150px !important;
}
.color-red {
  color: red !important;
}
.color-green {
  color: green !important;
}
</style>
